<template>
  <div class="">
    <h2>Config Parameters</h2>

    <ajax-table v-model:loading="ajaxTable.loading"
                v-model:search="ajaxTable.search"
                v-model:sort-by="ajaxTable.sortBy"
                v-model:sort-desc="ajaxTable.sortDesc"
                v-model:page="ajaxTable.page"
                v-model:items-per-page="ajaxTable.itemsPerPage"
                v-model:page-info="ajaxTable.pageInfo"
                :data="tableData"
                :headers="tableHeaders"
                :exportable="false"
                @loadData="loadData"
    >

      <template #search
                class="self-start flex items-center w-full md:w-auto ml:0 md:ml-2">
        <div class="w-full">
          <select2 class=""
                   name="serial_number"
                   :closeOnSelect="true"
                   :options='serialNumbers'
                   v-model:value="serial"
                   placeholder="Select A Serial Number">
          </select2>
        </div>
      </template>

      <template #above_table_center
                class="self-start flex items-center w-full md:w-auto ml:0 md:ml-2">
        <div class="w-full">
          <div class="inline w-1/5">
            <button class="items-center ml-2 px-12 py-1 border-2 border-blue-200 text-sm leading-5 font-sm font-sans rounded-md text-blue-700 bg-white-600 focus:outline-none focus:ring-blue-200"
                    @click="loadData">
              Refresh
            </button>
          </div>
        </div>
      </template>

      <template #items-per-page>
<!--        We leave this blank because we don't have a good way to do items per page...-->
        <span></span>
      </template>

      <!-- Parameter Name -->
      <template #col-1="tableProps">
        {{ tableProps.row.name }}
        <!-- Tooltip Part of this Does not Work, Possible Addition Later? -->
        <span   v-show="tableProps.row.packetQueued"
                class="tippy"
                :data-tippy-content="'Packet Queued: ' + tableProps.row.packetCreated">
          <span class="lnr icon-self-timer text-yellow-500 text-xs pl-4"></span>
        </span>
      </template>

      <!-- Parameter Value -->
      <template #col-2="tableProps">
        <input type="text"  class="w-1/2 items-center ml-2 px-4 py-2 border-2 border-blue-200 text-sm leading-5 font-sm font-sans rounded-md text-blue-700 bg-white-600 focus:outline-none focus:ring-blue-200"
               v-model="tableProps.row.value"
               placeholder="-">
      </template>

      <!-- Update Time -->
      <template #col-3="tableProps">
        {{ tableProps.row.update_time }}
      </template>

      <!-- Query Column -->
      <template #col-4="tableProps">
        <button class="w-full items-center ml-2 px-8 py-2 border-2 border-blue-200 text-sm leading-5 font-sm font-sans rounded-md text-blue-700"
                :class="[(tableProps.row.querying) ? standbyClass :
                                        ((tableProps.row.setting || tableProps.row.packetQueued || !canManageParameters) ? disabledClass : normalClass),
                                        ]"
                @click="queryParameter(tableProps.row)">
          {{ (tableProps.row.querying) ? "Querying" : tableProps.row.query }}
        </button>
      </template>

      <!-- Set Column -->
      <template #col-5="tableProps">
        <button  class="w-full items-center ml-2 px-8 py-2 border-2 border-blue-200 text-sm leading-5 font-sm font-sans rounded-md text-blue-700"
                 :class="[(tableProps.row.setting) ? standbyClass :
                                        ((tableProps.row.querying || tableProps.row.packetQueued || !canManageParameters) ? disabledClass : normalClass),]"
                 @click="setParameter(tableProps.row)">
          {{ (tableProps.row.setting) ? "Setting" : tableProps.row.set }}
        </button>
      </template>
    </ajax-table>
  </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import AjaxTable from "@/components/elements/AjaxTable";
import Select2 from "@/components/elements/select2"

export default {
  name: "ConfigParametersIndex",
  mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin,],
  components: { AjaxTable, Select2, },
  props: {
    serialNumbers: Object,
  },
  data() {
    return {
      tableHeaders: [
        {
          name: 'Parameter Name',
          key: 'name',
          sortBy: '',
        },
        {
          name: 'Parameter Value',
          key: 'type',
          sortBy: '',
        },
        {
          name: 'Update Time',
          key: 'meters',
          sortBy: '',
        },
        {
          name: 'Query',
          key: 'query',
          sortBy: '',
        },
        {
          name: 'Set',
          key: 'set',
          sortBy: '',
        }
      ],
      tableData: [],
      serial: null,

      // Editing Modal
      requestNumber: 0,
      normalClass: 'cursor-pointer bg-white-600 hover:bg-blue-200 active:bg-blue-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-400',
      standbyClass: 'cursor-not-allowed bg-yellow-100 hover:bg-yellow-100 focus:bg-yellow-100 active:bg-yellow-100',
      disabledClass: 'cursor-not-allowed bg-white-600 hover:bg-white-600 focus:bg-white-600 active:bg-white-600',

    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    loadData() {
      if(this.serial === null){
        return;
      }
      this.ajaxTable.loading = true
      this.ajaxTable.requestNumber++
      let params = JSON.parse(JSON.stringify(this.ajaxTable))
      params.requestNumber = this.ajaxTable.requestNumber
      axios.get(this.company.buildCompanyRoute('device/config-parameters/' + this.serial), {
        params: params,
      }).then(response => {
        let data = response.data
        console.log(data);
        data.forEach((item, index) => {
          data[index].querying = false
          data[index].setting = false
          let isExpired = false
        });

        this.tableData = data

        this.ajaxUpdateTableData(this.tableData)
      }).catch(error => {
        console.log(error)
      }).then(() => {
        this.ajaxTable.loading = false
      })
    },
    queryParameter(parameter) {
      if (!this.shouldProcessParameter(parameter)) {
        return
      }
      parameter.querying = true
      parameter.packetQueued = true
      axios.post(this.company.buildCompanyRoute('device/config-parameters'), {
        number: parameter.number,
        value: "",
        serial: parameter.serial,
      }).then(
        response => {
        }
      ).catch(
        error => {
        }
      )
    },
    setParameter(parameter) {
      if (!this.shouldProcessParameter(parameter)) {
        return
      }
      parameter.setting = true
      parameter.packetQueued = true
      axios.post(this.company.buildCompanyRoute('device/config-parameters'), {
        number: parameter.number,
        value: parameter.value,
        serial: parameter.serial,
      }).then(
        response => {
        }
      ).catch(
        error => {
        }
      )

    },
    shouldProcessParameter(parameter) {
      if (parameter.packetQueued || !this.canManageParameters) {
        return false
      }
      return !parameter.querying && !parameter.setting
    },
  },
  computed: {
    canManageParameters() {
      return this.permissions.can('manage_config_parameters')
    },
  },
  watch: {
      serial() {
          console.log('got an update on serial')
          this.loadData()
      },
  },
}
</script>

<style scoped>

</style>